import { PrizeCategory } from "../types/prize"

export interface FilterItem {
    id: string
    title: string
}

export const selectedFilterItems = (id: string, checked: boolean, categories: Array<string>) => {
    if (checked) {
        categories.push(id)
    } else {
        categories = categories.reduce((acc, item) => {
            if (item !== id) {
                acc.push(item)
            }
            return acc
        }, Array<string>())
    }
    return categories
}

export const searchSelect = (str: string, data: Array<PrizeCategory>) => {

    const result = data.reduce((acc, item) => {
        if (item.title) {
            if (item.title.toLowerCase().includes(str.toLowerCase())) {
                acc.push(item)
            }
        }
        return acc
    }, Array<PrizeCategory>())
    return result
}

export const selectedAfterSearch = (entities: Array<PrizeCategory>, selectedItems: Array<string>): Array<string> => {
    const result = selectedItems.reduce((acc, item) => {
        for (let index = 0; index < entities.length; index++) {
            const element = entities[index].id;
            if (element === item) {
                acc.push(item)
            }
        }
        return acc
    }, Array<string>())
    return result
}

export const selectSelectedFilter = (selectedData: Array<string>, gotData: Array<PrizeCategory>) => {
    const result = selectedData.reduce((acc, item) => {
        gotData.map((dataItem) => {
            if (dataItem.id === item) {
                acc.push(item)
            }
        })
        return acc
    }, Array<string>())
    return result
}